import React from 'react';
import { useRecordContext } from 'react-admin';

interface HumanRecordTitleProps {
    fields: string[];
    separator?: string;
    fallback?: string;
}

const HumanRecordTitle = ({
    fields,
    separator = ' — ',
    fallback = 'Fiche',
}: HumanRecordTitleProps) => {
    const record: any = useRecordContext();

    if (!record) {
        return <span>{fallback}</span>;
    }

    const values = fields
        .map((field) => String(record[field] || '').trim())
        .filter(Boolean);

    return <span>{values.join(separator) || fallback}</span>;
};

export default HumanRecordTitle;
